// Clima de Mazamitla para «Mi visita»: interpreta el pronóstico diario de Open-Meteo (códigos WMO) en algo que se entiende
// y en un consejo de Cleto. Puro (sin red): la consulta vive en /api/clima.
export type DiaClima = { fecha: string; codigo: number; max: number; min: number; lluvia: number };
export type Cielo = "despejado" | "nublado" | "niebla" | "llovizna" | "lluvia" | "tormenta";

export function cieloDe(codigo: number, lluvia = 100): Cielo {
  // El código diario marca «llovizna» con cualquier gota; si casi no hay probabilidad, para el visitante es un día nublado.
  if (codigo >= 51 && codigo <= 82 && lluvia < 35) return "nublado";
  if (codigo >= 95) return "tormenta";
  if (codigo >= 61 && codigo <= 82) return "lluvia";
  if (codigo >= 51 && codigo <= 57) return "llovizna";
  if (codigo === 45 || codigo === 48) return "niebla";
  if (codigo >= 2) return "nublado";
  return "despejado";
}

const NOMBRE: Record<Cielo, [string, string]> = {
  despejado: ["Despejado", "Clear"], nublado: ["Nublado", "Cloudy"], niebla: ["Neblina", "Fog"], llovizna: ["Llovizna", "Drizzle"], lluvia: ["Lluvia", "Rain"], tormenta: ["Tormenta", "Storm"],
};
export const nombreCielo = (c: Cielo, es: boolean) => NOMBRE[c][es ? 0 : 1];

/** Lo que Cleto aconseja ese día: lluvia primero, luego frío de noche (la sierra baja mucho), luego sol fuerte. */
export function consejoClima(d: DiaClima, es: boolean, hayNoche: boolean): string | null {
  const c = cieloDe(d.codigo, d.lluvia);
  if (c === "tormenta" || d.lluvia >= 60) return es ? `Ese día hay ${d.lluvia} % de probabilidad de lluvia: lleva impermeable y calzado que se pueda mojar.` : `${d.lluvia}% chance of rain that day: bring a raincoat and shoes that can get wet.`;
  if (d.lluvia >= 35) return es ? `Puede llover (${d.lluvia} %). Un impermeable ligero no estorba.` : `It may rain (${d.lluvia}%). A light raincoat won't hurt.`;
  if (d.min <= 8 && hayNoche) return es ? `En la noche bajará a ${Math.round(d.min)} °C: lleva chamarra y gorro.` : `It will drop to ${Math.round(d.min)}°C at night: bring a jacket and a hat.`;
  if (d.min <= 8) return es ? `Amanece fresco (${Math.round(d.min)} °C): lleva una chamarra ligera.` : `Chilly morning (${Math.round(d.min)}°C): bring a light jacket.`;
  if (d.max >= 27) return es ? `Hará calor (${Math.round(d.max)} °C): gorra, bloqueador y agua.` : `It'll be warm (${Math.round(d.max)}°C): cap, sunscreen and water.`;
  return null;
}

/** Convierte la respuesta diaria de Open-Meteo en días. Ignora lo que no venga completo. */
export function leerPronostico(json: unknown): DiaClima[] {
  const d = (json as { daily?: Record<string, unknown[]> })?.daily;
  if (!d || !Array.isArray(d.time)) return [];
  return d.time.map((f, i) => ({ fecha: String(f), codigo: Number(d.weather_code?.[i]), max: Number(d.temperature_2m_max?.[i]), min: Number(d.temperature_2m_min?.[i]), lluvia: Number(d.precipitation_probability_max?.[i] ?? 0) }))
    .filter((x) => /^\d{4}-\d{2}-\d{2}$/.test(x.fecha) && Number.isFinite(x.codigo) && Number.isFinite(x.max) && Number.isFinite(x.min));
}
